

























































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import CourierPickupsManagementTable from "./CourierPickupsManagementTable.vue";
import Accordion from "@/components/shared/Accordion.vue";
import ModalCPMEdit from "./ModalCPMEdit.vue";
import { ShipmentService } from "@/services/ShipmentService";
import { SearchMetadataDto } from "@/model/data.model";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import SearchFilters from "@/components/searchFilters.vue";
import { EventBus } from "@/event-bus";
import { PresetField } from "@/model/component.model";

@Component({
  components: {
    SearchFilters: SearchFilters,
    CourierPickupsManagementTable: CourierPickupsManagementTable,
    Accordion: Accordion,
    ModalCourier: ModalCPMEdit
  }
})
export default class CourierPickupsManagement extends Vue {
  filters = {
    documentType: null,
    courier: undefined
  };
  showCPMModal = false;
  itemToOpen = null;
  selectedDocuments = [];
  couriers: any[] = [];
  filtersAccordionActive = true;
  metadata = {} as SearchMetadataDto;
  metadataSearchFilter: any = {};
  presetsVisible: any[] = [];
  goEditable = false;

  @Validations()
  validations() {
    return {
      filters: {
        documentType: { required }
      }
    };
  }

  created() {
    this.getMetadata();
  }
  getMetadata() {
    const courierTrackingNumberVisible = this.$store.getters["customer/config"]
      .courierTrackingNumberVisible;
    ShipmentService.getMetadata("shipments", "shipments-pickup-mol").then(
      searchMeta => {
        this.metadata = searchMeta;
        const presets = courierTrackingNumberVisible
          ? searchMeta.presets
          : searchMeta.presets.filter(
              item =>
                item.field != "courierName" &&
                item.field != "shipmentTrackingNumber"
            );
        this.presetsVisible = presets.filter((el: any) => {
          return el.visible;
        });
        const filters = courierTrackingNumberVisible
          ? searchMeta.filters
          : searchMeta.filters.filter(item => item.field != "courierId");
        this.metadata.filters = filters.map(item => {
          return {
            ...item,
            label:
              item.field === "pickupRequested"
                ? "Pickup Request"
                : item.field === "customField.storeId"
                ? "Current MBE Center only"
                : ""
          };
        });
        filters.forEach(item => {
          if (item.type === "DATE") {
            this.metadataSearchFilter = {
              ...this.metadataSearchFilter,
              [item.field]:
                this.formatDateDefaultValue(item.defaultValue) || null
            };
          } else {
            this.metadataSearchFilter = {
              ...this.metadataSearchFilter,
              [item.field]: item.defaultValue || null
            };
          }
        });
      }
    );
  }

  getEditDisabled() {
    if (this.selectedDocuments.length !== 1) return true;
    else if (this.selectedDocuments.length === 1) {
      if (this.selectedDocuments[0].shipmentSource === "HUB_MANUAL") {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  formatDateDefaultValue(value) {
    if (value === "nextWeek") {
      const afterOneWeek = new Date().setDate(new Date().getDate() + 7);
      return [new Date(), new Date(afterOneWeek)];
    } else {
      return [new Date(), new Date()];
    }
  }

  toggleCPMModal() {
    this.showCPMModal = !this.showCPMModal;
    this.goEditable = false;
  }

  editCPMModal(value) {
    this.itemToOpen = value[0];
    this.goEditable = true;
    this.showCPMModal = !this.showCPMModal;
  }

  openCPMModal(openItem: any) {
    this.itemToOpen = openItem;
    this.showCPMModal = !this.showCPMModal;
    this.goEditable = false;
  }

  handleSelectedCPMChange(selected: number[]) {
    if (selected.length > 0) {
      this.selectedDocuments = selected;
    } else {
      this.selectedDocuments = [];
    }
  }

  handleSingleSelectedCPMChange(sped: any[]) {
    this.selectedDocuments = sped.filter(item => item.selected === true);
  }

  searchFilter(value) {
    EventBus.$emit("search-on-pickup-management", value);
  }
}
